var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGnbEquipmentSettingOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E9F0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2692_100053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3797 17.9396C16.2897 18.0196 16.1997 18.0996 16.1197 18.1796C14.9197 19.3796 14.6397 21.1296 15.2597 22.5996L8.46972 29.3896C7.87972 29.9796 7.82972 30.9496 8.40972 31.5496C8.40972 31.5496 8.41972 31.5596 8.42972 31.5696C8.43972 31.5796 8.43972 31.5796 8.44972 31.5896C9.04972 32.1696 10.0197 32.1196 10.6097 31.5296L17.3997 24.7396C18.8697 25.3596 20.6197 25.0796 21.8197 23.8796C23.0197 22.6796 23.2997 20.9296 22.6797 19.4596L20.5897 21.5496L19.1697 20.8396L18.4597 19.4196L20.5497 17.3296C19.1897 16.7496 17.5697 16.9596 16.3897 17.9496M9.39972 31.0096C9.13972 31.0096 8.92972 30.7996 8.92972 30.5396C8.92972 30.2796 9.13972 30.0696 9.39972 30.0696C9.65972 30.0696 9.86972 30.2796 9.86972 30.5396C9.86972 30.7996 9.65972 31.0096 9.39972 31.0096Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 9.5H15.5V14.84H30.5V9.5Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 30H15.25C14.56 30 14 29.44 14 28.75V9.25C14 8.56 14.56 8 15.25 8H30.75C31.44 8 32 8.56 32 9.25V28.75C32 29.44 31.44 30 30.75 30ZM16.25 28.5H29.75C30.16 28.5 30.5 28.17 30.5 27.75V9.5H15.5V27.75C15.5 28.16 15.83 28.5 16.25 28.5Z",
    fill: "#4073F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2692_100053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbEquipmentSettingOn);
export default __webpack_public_path__ + "static/media/gnb_equipment_setting_on.b33af2b848272b7ace661e73982d6b3e.svg";
export { ForwardRef as ReactComponent };